/* ============================================================================
   GOBYE — "Tükeniyor!" rozeti — saat ikonu
   ----------------------------------------------------------------------------
   NEDEN JS: tema, stok ikonunu kendi SVG'siyle (amber nokta) render ediyor.
   Bir SVG'nin İÇİNDEKİ parçaları CSS ile değiştirmek mümkün değil, bu yüzden
   ikonun içeriği burada değiştiriliyor.

   IKON: düz (flat) konturlu saat — referans rozetteki gibi. Kontur 2.4
   seçildi; önceki 1.5'lik versiyon küçük boyutta cılız görünüyordu.
   Gradyan/hacim YOK — referans ikon tamamen düz tek renk.

   Sadece DÜŞÜK STOK ikonuna (.product-inventory__icon-low) dokunuyor.
   ============================================================================ */
(function () {
  var SVG =
    '<svg class="gobye-clock" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<circle class="gobye-clock__ring" cx="12" cy="12" r="8.6"/>' +
      '<path class="gobye-clock__hour" d="M12 12V7.1"/>' +
      '<path class="gobye-clock__sweep" d="M12 12h4.1"/>' +
    '</svg>';

  function paint() {
    var nodes = document.querySelectorAll('product-inventory .product-inventory__icon-low');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      /* Bayrak innerHTML'den ONCE set ediliyor: yazma işlemi observer'ı yeniden
         tetiklediğinde bu öğe atlanır, sonsuz döngü oluşmaz. */
      if (el.dataset.gobyeClock === '1') continue;
      el.dataset.gobyeClock = '1';
      el.innerHTML = SVG;
    }
  }

  function boot() {
    paint();

    /* Varyant değişiminde tema product-inventory'yi Section Rendering ile
       yeniden basıyor — yeni gelen ikonu da yakalamak için izliyoruz.
       setTimeout ile geciktiriliyor: requestAnimationFrame'e GÜVENME. */
    var bekleyen = null;
    var obs = new MutationObserver(function () {
      if (bekleyen) return;
      bekleyen = setTimeout(function () {
        bekleyen = null;
        paint();
      }, 120);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
